<div tabindex="0" class="help-profile-card row" *ngIf="data">
    <div class="help-profile-card__icon">
    </div>
    <div class="help-profile-card__header">
        {{data.title}}
    </div>
    <div class="help-profile-card__description" *ngIf="data.content">
        <div class="help-profile-card__content storyblok-content" [innerHTML]="data.content | storyblokRichtext">
        </div>
    </div>
    <div class="help-profile-card__button hidden">
        <button class="btn btn--secondary">
            {{ 'Go to dashboard' | translate}}
        </button>
    </div>
</div>